import PropTypes from 'prop-types';
import React, { Component, ComponentProps } from 'react';
import styled from 'styled-components';

import { Maybe } from '../../../graphql/schema/p4types';

const Div = styled.label`
  display: inline-block;
  width: 100%;
  margin: 0;
  vertical-align: sub;
  font-weight: normal;
  font-size: 0.925rem;
  font-weight: 300;
  color: ${(props) => props.theme.colors.inputLabel};
  text-align: ${(props) => props.textAlign};
`;

const ColumnLabel = (props: ComponentProps<typeof Div> & { label?: Maybe<string> }) => {
  const { label } = props;
  return <Div {...props}>{label}</Div>;
};

export default ColumnLabel;
